import React, { forwardRef } from 'react'
import { Checkbox } from 'antd'

import useRequestOccasions from 'hooks/useRequestOccasions'

import styles from './RequestOccasionCheckboxGroup.module.css'

const RequestOccasionSelect = (props, ref) => {
  const { productType, ...rest } = props
  const { error, requestOccasions = [] } = useRequestOccasions({
    productType,
  })
  if (error) return <div>Error: {JSON.stringify(error, null, 2)}</div>

  const checkBoxOptions = requestOccasions.reduce((acc, curr) => {
    acc.push({
      label: curr.title,
      value: curr.id,
    })
    return acc
  }, [])

  return (
    <Checkbox.Group
      className={styles.occasionsCheckboxes}
      data-cy="requestoccasioncheckboxgroup"
      ref={ref}
      options={checkBoxOptions}
      {...rest}
    />
  )
}

export default forwardRef(RequestOccasionSelect)
